import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { Plan as PlanV3 } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { allowsFutureStartDate, mapPerksV3ToV2, mapPricingV3ToV2 } from '@wix/pricing-plans-utils';

/**
 * Maps a V3 Plan to a V2 PublicPlan shape for use in the blocks widget's external Velo `onSelect` handler.
 * Scoped to the blocks widget — not intended for use elsewhere.
 *
 * Differences from the shared `mapPlanV3ToV2` util:
 * - Returns `PublicPlan` (viewer type) instead of `Plan` (admin type) — omits `public`, `archived`, `hasOrders`
 * - `allowFutureStartDate` falls back to `false` for unknown start types instead of throwing
 * - Omits `clientData` (@internal field not used by Velo handlers)
 */
export function mapPlanV3ToPublicPlan(plan: PlanV3): PublicPlan {
  return {
    id: plan.id ?? undefined,
    name: plan.name,
    description: plan.description,
    perks: mapPerksV3ToV2(plan),
    pricing: mapPricingV3ToV2(plan),
    primary: plan.primary,
    createdDate: plan.createdDate,
    updatedDate: plan.updatedDate,
    slug: plan.slug,
    maxPurchasesPerBuyer: plan.maxPurchasesPerBuyer,
    allowFutureStartDate: allowsFutureStartDate(plan.pricingVariants![0]),
    buyerCanCancel: plan.buyerCanCancel,
    termsAndConditions: plan.termsAndConditions,
    formId: plan.formId,
  };
}
